import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Btn, Modal, Field, Input } from "@/components/ui-kit";
import { formatINR, formatDate } from "@/lib/format";
import { Plus, MapPin } from "lucide-react";

const empty = { booking_id: "", start_km: 0, end_km: 0, toll: 0, parking: 0, driver_allowance: 0, other_charges: 0, total_amount: 0, notes: "" };

export default function Trips() {
  const [items, setItems] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const [t, b] = await Promise.all([api.get("/owner/trips"), api.get("/owner/bookings")]);
    setItems(t.data); setBookings(b.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e?.preventDefault();
    const numFields = ["start_km","end_km","toll","parking","driver_allowance","other_charges"];
    const data = { ...editing };
    numFields.forEach(k => data[k] = Number(data[k] || 0));
    data.total_amount = (data.end_km - data.start_km) * 12 + data.toll + data.parking + data.driver_allowance + data.other_charges;
    await api.post("/owner/trips", data);
    setOpen(false); setEditing(null); load();
  };

  return (
    <div data-testid="trips-page">
      <PageHeader title="Trip Sheets" subtitle="Start KM, End KM, toll, parking and driver allowance."
        actions={<Btn data-testid="trip-add" onClick={() => { setEditing({...empty}); setOpen(true); }}><Plus className="h-4 w-4" /> New Trip Sheet</Btn>}
      />
      <div className="bg-white border border-zinc-200 rounded-lg overflow-hidden">
        <table className="tbl">
          <thead><tr><th>Trip #</th><th>Booking</th><th>Start KM</th><th>End KM</th><th>Toll</th><th>Parking</th><th>Driver Allow.</th><th>Total</th><th>Date</th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={9} className="text-center py-10 text-zinc-500"><MapPin className="h-8 w-8 mx-auto mb-2 text-zinc-300" /> No trip sheets yet.</td></tr>
            ) : items.map((t) => {
              const bk = bookings.find((b) => b.id === t.booking_id);
              return (
                <tr key={t.id}>
                  <td className="font-mono text-xs">{t.trip_number}</td>
                  <td>{bk?.booking_number || "—"}</td>
                  <td>{t.start_km}</td><td>{t.end_km}</td>
                  <td>{formatINR(t.toll)}</td><td>{formatINR(t.parking)}</td><td>{formatINR(t.driver_allowance)}</td>
                  <td className="font-mono font-bold">{formatINR(t.total_amount)}</td>
                  <td className="text-zinc-500">{formatDate(t.created_at)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Modal open={open} size="lg" onClose={() => setOpen(false)} title="New Trip Sheet" testid="trip-modal"
        footer={<><Btn variant="outline" onClick={() => setOpen(false)}>Cancel</Btn><Btn data-testid="trip-save" onClick={submit}>Save</Btn></>}>
        {editing && (
          <form onSubmit={submit} className="grid grid-cols-2 gap-4">
            <div className="col-span-2"><Field label="Booking" required>
              <select className="w-full px-3 py-2 rounded-md border border-zinc-300 bg-white text-sm" value={editing.booking_id} onChange={(e) => setEditing({...editing, booking_id: e.target.value})} required data-testid="trip-booking">
                <option value="">— Select booking —</option>
                {bookings.map((b) => <option key={b.id} value={b.id}>{b.booking_number} · {b.client_name} · {b.pickup}</option>)}
              </select>
            </Field></div>
            <Field label="Start KM"><Input type="number" value={editing.start_km} onChange={(e) => setEditing({...editing, start_km: e.target.value})} data-testid="trip-start-km" /></Field>
            <Field label="End KM"><Input type="number" value={editing.end_km} onChange={(e) => setEditing({...editing, end_km: e.target.value})} data-testid="trip-end-km" /></Field>
            <Field label="Toll"><Input type="number" value={editing.toll} onChange={(e) => setEditing({...editing, toll: e.target.value})} /></Field>
            <Field label="Parking"><Input type="number" value={editing.parking} onChange={(e) => setEditing({...editing, parking: e.target.value})} /></Field>
            <Field label="Driver Allowance"><Input type="number" value={editing.driver_allowance} onChange={(e) => setEditing({...editing, driver_allowance: e.target.value})} /></Field>
            <Field label="Other Charges"><Input type="number" value={editing.other_charges} onChange={(e) => setEditing({...editing, other_charges: e.target.value})} /></Field>
          </form>
        )}
      </Modal>
    </div>
  );
}
